import { Collections, IncidentReviewRequest } from "api";
import { useCollection } from "api/hooks/useCollection";
import { WhereOptions } from "react-redux-firebase";

interface IncidentReviewRequestsHookOptions {
    userId?: string;
    roundId: string;
}

export const useIncidentReviewRequests = (
    options: IncidentReviewRequestsHookOptions
): IncidentReviewRequest[] => {
    const { userId, roundId } = options;
    const where: WhereOptions[] = [["roundId", "==", roundId]];

    if (userId) {
        where.push(["requestUserId", "==", userId]);
    }

    return (
        useCollection<IncidentReviewRequest[]>(
            {
                collection: Collections.INCIDENT_REVIEW_REQUESTS,
                where,
                storeAs: `myReviewRequests${roundId}`,
            },
            true
        ) || []
    );
};
